function decodeHtmlEntities(value) {
  return String(value || "")
    .replace(/&amp;/gi, "&")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;|&apos;/gi, "'");
}

export function mapEmbedUrlFromInput(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";

  const quotedSrc = raw.match(/\bsrc\s*=\s*(["'])(.*?)\1/i);
  if (quotedSrc?.[2]) return decodeHtmlEntities(quotedSrc[2]).trim();

  const bareSrc = raw.match(/\bsrc\s*=\s*([^\s>]+)/i);
  if (bareSrc?.[1]) return decodeHtmlEntities(bareSrc[1]).replace(/^['"]|['"]$/g, "").trim();

  return decodeHtmlEntities(raw).trim();
}

export function isGoogleMapsShareUrl(value) {
  const candidate = mapEmbedUrlFromInput(value);
  if (!candidate || !/^https?:\/\//i.test(candidate)) return false;
  try {
    const url = new URL(candidate);
    return url.protocol === "https:" && url.hostname.toLowerCase() === "maps.app.goo.gl";
  } catch {
    return false;
  }
}

export function isSupportedMapEmbedUrl(value) {
  const candidate = mapEmbedUrlFromInput(value);
  if (!candidate || !/^https?:\/\//i.test(candidate)) return false;
  try {
    const url = new URL(candidate);
    const host = url.hostname.toLowerCase();
    const google =
      (host === "google.com" || host.endsWith(".google.com")) &&
      url.pathname.includes("/maps");
    const openStreetMap =
      host === "www.openstreetmap.org" && url.pathname.includes("/export/embed");
    return google || openStreetMap;
  } catch {
    return false;
  }
}

export function mapEmbedInputError(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (isSupportedMapEmbedUrl(raw) || isGoogleMapsShareUrl(raw)) return "";
  return "Pegá el vínculo de Google Maps que sale de Compartir > Copiar vínculo, una URL embebida o el iframe completo.";
}
